import createModel from 'utils/model'
import _ from 'lodash'
import {
    getTableData,
    downloadTemplate,
    importGroupLink,
    downloadStoreGroupTemplate,
    importStoreGroup,
} from 'crm/services/drainage-channel-manage'

function getInitTableParamsState() {
    return {
        keyword: undefined,
        user_id: undefined,
        limit: 10,
        offset: 0,
    }
}

function getInitTableState() {
    return {
        params: getInitTableParamsState(),
        total: 0,
        current: 1,
        tableData: [],
    }
}

export default createModel({
    namespace: 'crm_drainage_channelManage',

    state: {
        ...getInitTableState(),
    },

    effects: {
        *getTableData({payload}, {select, call, put}) {
            const {params, current} = yield select(
                ({crm_drainage_channelManage}) => crm_drainage_channelManage,
            )

            const newParams = _.cloneDeep(params)

            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }

            const res = yield call(getTableData, newParams)

            yield put({
                type: 'setProperty',
                payload: {
                    tableData: res.data,
                    total: _.get(res, 'pagination.rows_found', 0),
                    current: _.get(payload, 'page', current),
                },
            })
        },
        *downloadTemplate({payload}, {call}) {
            return yield call(downloadTemplate, payload)
        },
        *importGroupLink({payload}, {call}) {
            return yield call(importGroupLink, payload)
        },
        *downloadStoreGroupTemplate({payload}, {call}) {
            return yield call(downloadStoreGroupTemplate, payload)
        },
        *importStoreGroup({payload}, {call}) {
            return yield call(importStoreGroup, payload)
        },
    },

    reducers: {
        resetTableParams(state) {
            return {...state, params: getInitTableParamsState()}
        },
        resetTable(state) {
            return {...state, ...getInitTableState()}
        },
        mergeTableParams(state, action) {
            return {...state, params: {...state.params, ...action.payload}}
        },
    },
})
